import {
	Component,
	Input,
	OnInit,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { PartnerInsightService } from 'app/services/partner/partner-insights.service';
import { BaseInsightRequest } from 'app/models/partner/base-insight-request.model';
import {
	ProductCombinationInsight,
	ProductCombinationInsightSplit,
} from 'app/models/partner/insight-models';
import { MessageService } from 'primeng/api';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from 'app/utils/utils';
import { GetMostPopularCombinationsResponse } from 'app/partner/response-insight.model';
import { Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
	selector: 'most-popular-combinations',
	templateUrl: './most-popular-combinations.component.html',
	styleUrls: ['./most-popular-combinations.component.scss'],
})
export class MostPopularCombinationsComponent implements OnInit, OnChanges {
	@Input() locationId: number = 0;
	@Input() fromDate: Date = new Date();
	@Input() toDate: Date = new Date();

	public combinationsDataSource =
		new MatTableDataSource<ProductCombinationInsightSplit>();
	loading = false;
	isEmpty = false;
	public combinationDisplayedColumns: string[] = [
		'Combination',
		'Quantity',
		'SalesRevenue',
	];

	constructor(
		private partnerInsightService: PartnerInsightService,
		private messageService: MessageService,
		private liveAnnouncer: LiveAnnouncer
	) {}

	ngOnInit() {
		this.loadMostPopularCombinations();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['locationId'] || changes['fromDate'] || changes['toDate']) {
			this.loadMostPopularCombinations();
		}
	}

	onCombinationsSortChange(sortState: Sort) {
		if (sortState.direction) {
			this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
		} else {
			this.liveAnnouncer.announce('Sorting cleared');
		}
	}

	public loadMostPopularCombinations() {
		this.loading = true;
		this.isEmpty = false;

		const request: BaseInsightRequest = {
			TimeZoneOffset: Utils.getTimezoneOffset(),
			LocationId: this.locationId,
			FromDate: this.fromDate,
			ToDate: this.toDate,
			Skip: 0,
			Take: 5,
		};

		this.partnerInsightService
			.getMostPopularCombinations(request, this.messageService)
			.then((response: GetMostPopularCombinationsResponse) => {
				if (response.Success && response.Items && response.Items.length > 0) {
					const mostPopularCombinations = response.Items.map(
						(item: ProductCombinationInsight) => ({
							Combination: item.Combination.split('+ '),
							Images: item.Images.split(','),
							Quantity: item.Quantity,
							SalesRevenue: item.SalesRevenue,
						})
					);
					this.combinationsDataSource.data = mostPopularCombinations;
					this.isEmpty = false;
				} else {
					this.combinationsDataSource.data = [];
					this.isEmpty = true;
				}
			})
			.catch((error) => {
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Failed to load most popular combinations',
				});
				this.combinationsDataSource.data = [];
				this.isEmpty = true;
			})
			.finally(() => {
				this.loading = false;
			});
	}
}
